// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_SalvarTodosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/order_item_requests/salvar_todos
 *
 * Bulk replace all customer requests for an order item.
 * Mirrors Item_attributes_SalvarAtributosCategoriaInput pattern for array payloads.
 *
 * Fields:
 *  - $requests (required, list): each entry must carry a non-empty
 *    `description`; `photo` and `display_order` are optional. The Row shape
 *    is declared on {@see Order_item_requests_SalvarTodosRequestRow} so the
 *    Spatie TS pipeline projects a typed list (no `unknown[]`) and the
 *    runtime harness can validate per-item shape.
 */
import type { Order_item_requests_SalvarTodosRequestRow } from './Order_item_requests_SalvarTodosRequestRow'
import { registerContract } from './validate'

export interface Order_item_requests_SalvarTodosInput {
requests?: Order_item_requests_SalvarTodosRequestRow[]
}

registerContract('Order_item_requests_SalvarTodosInput', {
  requests: {
    type: 'array',
    required: false,
    items: {
      description:   { type: 'string',  required: true },
      photo:         { type: 'string',  required: false },
      display_order: { type: 'number',  required: false },
    },
  },
})
